import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "input-box" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AiAssistant = _resolveComponent("AiAssistant")
  const _component_UserMessage = _resolveComponent("UserMessage")
  const _component_AIMessage = _resolveComponent("AIMessage")
  const _component_UserCancelled = _resolveComponent("UserCancelled")
  const _component_ChatError = _resolveComponent("ChatError")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_AIAction = _resolveComponent("AIAction")
  const _component_ChatInput = _resolveComponent("ChatInput")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ai-chat", [$props.mode]])
  }, [
    _withDirectives((_openBlock(), _createBlock(_component_ScrollBar, {
      ref: "scroller",
      class: "scroller",
      onWheel: $options.onWheel,
      onScroll: $options.onScroll
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.history, (item, idx) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            _createCommentVNode(" We make stop propagation for wheel to avoid scrolling behaviour errors with autoscrolling "),
            (item.type === 'assistant')
              ? (_openBlock(), _createBlock(_component_AiAssistant, {
                  key: idx,
                  ref_for: true,
                  ref: "history",
                  "chat-id": $props.chatId,
                  class: "entry delay-in-1000",
                  style: _normalizeStyle({minHeight: $options.getMinHeight(idx)}),
                  mode: $props.mode,
                  item: item,
                  "last-answer": $options.last_answer_idx === idx,
                  generating: $props.generating,
                  idx: idx,
                  readonly: $props.readonly,
                  restricted: idx <= $props.refHistoryLen,
                  onTextAdded: $options.onTextAdded,
                  onAskAi: _cache[0] || (_cache[0] = $event => (_ctx.$emit('ask-ai', $event))),
                  onLike: $event => (_ctx.$emit('like', {idx, feedback: $event})),
                  onDislike: $event => (_ctx.$emit('dislike', {idx, feedback: $event})),
                  onSave: $event => (_ctx.$emit('save', {idx, text: $event})),
                  onMeetingSave: $event => (_ctx.$emit('meeting-save', {idx})),
                  onPodcastSave: $event => (_ctx.$emit('podcast-save', {idx})),
                  onRefrag: $event => (_ctx.$emit('refrag', {idx, range: $event})),
                  onOnboardingCompleted: _cache[1] || (_cache[1] = $event => ($options.onOnboardingCompleted($event))),
                  onWheel: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                }, null, 8 /* PROPS */, ["chat-id", "style", "mode", "item", "last-answer", "generating", "idx", "readonly", "restricted", "onTextAdded", "onLike", "onDislike", "onSave", "onMeetingSave", "onPodcastSave", "onRefrag"]))
              : _createCommentVNode("v-if", true),
            (item.type === 'user')
              ? (_openBlock(), _createBlock(_component_UserMessage, {
                  key: idx,
                  ref_for: true,
                  ref: "history",
                  "copied-title": idx === 0 && !!$props.refHistoryLen,
                  data: item.data,
                  class: "user-message entry delay-in-1000",
                  mode: $props.mode,
                  onPromptSave: $event => (_ctx.$emit('prompt-save', {idx}))
                }, null, 8 /* PROPS */, ["copied-title", "data", "mode", "onPromptSave"]))
              : _createCommentVNode("v-if", true),
            (item.type === 'assistant-error')
              ? (_openBlock(), _createBlock(_component_AIMessage, {
                  key: idx,
                  ref_for: true,
                  ref: "history",
                  error: "",
                  class: "ai-message entry delay-in-1000",
                  text: item.data.text,
                  style: _normalizeStyle({minHeight: $options.getMinHeight(idx)})
                }, null, 8 /* PROPS */, ["text", "style"]))
              : _createCommentVNode("v-if", true),
            (item.type === 'user-cancelled')
              ? (_openBlock(), _createBlock(_component_UserCancelled, {
                  key: idx,
                  ref_for: true,
                  ref: "history",
                  class: "entry delay-in-1000",
                  mode: $props.mode,
                  text: item.data.text,
                  style: _normalizeStyle({minHeight: $options.getMinHeight(idx)})
                }, null, 8 /* PROPS */, ["mode", "text", "style"]))
              : _createCommentVNode("v-if", true),
            (item.type === 'error')
              ? (_openBlock(), _createBlock(_component_ChatError, {
                  key: idx,
                  ref_for: true,
                  ref: "history",
                  "chat-id": $props.chatId,
                  data: item.data,
                  class: "entry delay-in-1000",
                  mode: $props.mode,
                  style: _normalizeStyle({minHeight: $options.getMinHeight(idx)})
                }, null, 8 /* PROPS */, ["chat-id", "data", "mode", "style"]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onWheel", "onScroll"])), [
      [_directive_resize, $options.setClientHeight, "100"]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AIAction, {
        show: !!$options.ai_question,
        "arrow-down": $data.question_position === 'below',
        class: "ai-action",
        onClick: $options.scrollToReasoning
      }, null, 8 /* PROPS */, ["show", "arrow-down", "onClick"]),
      (!$props.readonly)
        ? (_openBlock(), _createBlock(_component_ChatInput, {
            key: 0,
            ref: "input",
            modelValue: $data.input_text,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.input_text) = $event)),
            shadow: true,
            controls: _ctx.$responsive.desktop && $props.mode !== 'onboarding',
            fade: $props.mode !== 'onboarding',
            description: $props.description,
            placeholder: $props.placeholder,
            generating: $props.generating,
            disabled: $options.input_disabled,
            "chat-id": $props.chatId,
            onRegenerate: _cache[4] || (_cache[4] = params => _ctx.$emit('regenerate', params)),
            onStop: _cache[5] || (_cache[5] = $event => ($options.stop()))
          }, null, 8 /* PROPS */, ["modelValue", "controls", "fade", "description", "placeholder", "generating", "disabled", "chat-id"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}